import React, { useEffect, useState } from 'react'
import FFCAProgrammeWiseDetails from './FFCAProgrammeWiseDetails'
import FFCADeficiencyRepot from './FFCADeficiencyRepot'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { config } from '../../CommonUtils/CommonURLS';
import { CommonAxiosGet } from '../../CommonUtils/CommonAxios';
import Swal from 'sweetalert2';
import CommonFormHeading from '../../CommonUtils/CommonFormHeading';
import AfflProceedCourseCnfmOamdc from '../DeanLogin/AfflOrdOamdcVerif2023Tabs/AfflProceedCourseCnfmOamdc';
import AfflProceedConfrmDetails from '../DeanLogin/AfflOrdVerifTabs/AfflProceedConfrmDetails';
import { ProgressBar } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { GetFFCAStatus } from '../../Reducers/AffiliationCommonservice';
export default function FFCADeficiencyTabs() {
  const ffcaStatus = useSelector((state) => state?.commonMastersReducer?.ffcaStatus);
  const acYear = sessionStorage.getItem('ac_year');
  const userid = (sessionStorage?.getItem('user_id') || "").startsWith('ffca_') ? sessionStorage?.getItem('user_id').split('_')[1] : sessionStorage.getItem('user_id');
  const [showFFCAReportValues, setFFCAReportValues] = useState([]);
  const [index, setIndex] = useState(0);

  function GetFFCADetailsData() {
    let url = config.url.API_URL + `getafflffcadefdtls`;
    CommonAxiosGet(url).then((res) => {
      if (res?.data?.scode === '01') {
        setFFCAReportValues(res?.data?.data)
      }

      else {
        setFFCAReportValues([])
      }
    })
  }

  const [clgtype, setClgtype] = useState('');
  function GetOAMDCClgType() {
    let url = config.url.API_URL + `getOamdcType`
    CommonAxiosGet(url).then((res) => {
      if (res?.data) {
        setClgtype(res?.data)

      } else {
        setClgtype([])
      }
    })
  }



  const [programWiseData, setProgramWiseData] = useState([]);
  const [corpusdata, Setcorpusdata] = useState([])
  function GetProgramWise() {
    let url = config.url.API_URL + `getafflfacultydef`
    CommonAxiosGet(url).then((res) => {
      if (res?.data) {
        setProgramWiseData(res?.data?.facultydetails)


      }
      if (res?.data?.corpus_status === true) {
        Setcorpusdata(res?.data?.corpus)
      }
      else {
        setProgramWiseData([])
        Setcorpusdata([])
      }
    })
  }


  const handleTabSelect = (newIndex) => {
    const isFFCAEmpty = showFFCAReportValues?.length === 0 || showFFCAReportValues?.length === null || showFFCAReportValues?.length === '' || showFFCAReportValues?.length === undefined || showFFCAReportValues === "No data found";
    const isProgramWiseEmpty = programWiseData?.length === 0 || programWiseData?.length === null || programWiseData?.length === '' || programWiseData?.length === undefined || programWiseData === "No data found";
    if (newIndex === 1 && isFFCAEmpty) {
      Swal.fire({
        icon: 'warning',
        title: 'Submit Required',
        text: 'Please fill in the FFCA Deficiency form (tab 1) before proceeding.',
        backdrop: false,
      });
      return false;
    }
    if (newIndex === 2) {
      if (isFFCAEmpty || isProgramWiseEmpty) {

        Swal.fire({
          icon: 'warning',
          title: 'Submit Required',
          text: 'Please fill in the FFCA Deficiency form (tab 1) and Programme‑Wise Details (tab 2) before proceeding to Course Confirmation.',
          backdrop: false
        });
        return false;
      }
    }

    setIndex(newIndex);
    return true;
  };

  const handleSuccessSubmit = () => {
    GetFFCADetailsData();
    GetProgramWise();
    setIndex(1);

  };

  const handleSecSuccessSubmit = () => {
    GetProgramWise();
    GetFFCADetailsData();
    setIndex(2);


  };


  useEffect(() => {
    GetFFCADetailsData();
    GetOAMDCClgType();
    GetProgramWise();
    GetFFCAStatus(userid, acYear);

  }, [])
  useEffect(() => {
    let percentage = 0;

    // if first API data is available
    if (showFFCAReportValues) {
      percentage += 33.33;
    }

    // if second API data is available
    if (corpusdata) {
      percentage += 33.33;
    }

    // if ffcaStatus is 1
    if (ffcaStatus === '1') {
      percentage += 33.34;
    }

  }, [])
  let completedParts = 0;

  if (showFFCAReportValues?.length > 0) completedParts += 1;
  if (programWiseData?.length > 0) completedParts += 1;
  if (ffcaStatus === '1') completedParts += 1;
  const percentage = (completedParts / 3) * 100;
  return (

    <div>
      <CommonFormHeading heading="FFCA Deficiencies" />
      {percentage != 0 ? (<>
        <ProgressBar animated now={percentage} label={`${percentage.toFixed(2)}%`} variant="success" className='inner-progress' style={{ height: "20px", fontSize: "18x" }} /><br />

      </>) : <div className='text-center border mt-2 mb-2'><span className='text-danger fw-bold'>Status:</span><b>This Application not yet started</b></div>}

      <Tabs selectedIndex={index} onSelect={handleTabSelect}>
        <TabList className="tabs-container affl-tabcontainer">
          <Tab className="tab">FFCA Deficiency </Tab>
          <Tab className="tab"  >FFCA Programme Wise Details</Tab>
          <Tab className="tab"  >Course Details Confirmation</Tab>

        </TabList>

        <TabPanel>
          <FFCADeficiencyRepot name={showFFCAReportValues} setIndex={setIndex} x={GetFFCADetailsData}
            onSuccessSubmit={handleSuccessSubmit}></FFCADeficiencyRepot>
        </TabPanel>
        <TabPanel>
          <FFCAProgrammeWiseDetails name={programWiseData} setIndex={setIndex} x={GetProgramWise} onSuccessSubmit={handleSecSuccessSubmit}></FFCAProgrammeWiseDetails>
        </TabPanel>

        <TabPanel>
          {clgtype !== "Nonoamdc" ? (
            <AfflProceedCourseCnfmOamdc />
          ) : (<AfflProceedConfrmDetails />)}

        </TabPanel>
      </Tabs>
    </div>
  )
}
